import { render } from "./logo-leaderboard.svg?vue&type=template&id=752a9e8d"
const script = {}
script.render = render

export default script